module.exports = __webpack_public_path__ + "static/media/index.c43f9a4c.scss";


//////////////////
// WEBPACK FOOTER
// ./src/scss/index.scss
// module id = 477
// module chunks = 0